module.exports = __webpack_public_path__ + "img/icon_wuzicaigou.c5b2270c.png";